<table
  [ngClass]="{ fewCols: columns.length < 4 }"
  class="comp table-striped compSize borderless"
  width="100%"
  cellspacing="0"
  border="0"
>
  <thead>
    <tr>
      <!-- panel titles -->
      <ng-container *ngFor="let panel of panels">
        <!-- angular doesn't support more than one structural directive on the same element: use ng-container for *ngFor (not stamped to the DOM)-->
        <th
          class="pillar-th"
          *ngIf="panel.studentKpiIds && panel.studentKpiIds.length > 0"
          [attr.colspan]="panel.studentKpiIds ? panel.studentKpiIds.length : 0"
        >
          <p
            class="pillar-title"
            [ngClass]="{
              'purple-title-view': panel.isViewPanel,
              'purple-title-group': panel.isGroupPanel
            }"
          >
            {{ panel.title }}
          </p>
          <div class="purple-subtitle-group" *ngIf="panel.isGroupPanel">
            <group-criteria-panel-display
              [groupCriteria]="groupCriteria"
              [columns]="columns"
            ></group-criteria-panel-display>
          </div>
        </th>
      </ng-container>
    </tr>
    <tr>
      <!-- kpi titles -->
      <th
        *ngFor="let column of columns; let i = index; let last = last"
        class="metric-header"
      >
        <div class="title-and-dropdown">
          <div
            [tooltip]="titleTooltip"
            [placement]="last ? 'left' : 'top'"
            container="body"
            [adaptivePosition]="false"
          >
            <p
              class="kpi-title"
              data-id="OurStudentsHeader.Metric.{{ column.id }}"
            >
              {{ column.title }}
            </p>
          </div>
          <div
            dropdown
            container="body"
            [autoClose]="false"
            [isOpen]="status.openDropdown == i"
          >
            <button
              dropdownToggle
              type="button"
              class="btn btn-link dropdownToggle sort-filter-dropdown"
              (click)="toggleDropdown(i)"
            >
              <sort-filter-images
                [sortColumns]="sortsAndFilters?.sortColumns"
                [filterColumns]="sortsAndFilters?.filterColumns"
                [column]="column"
                [status]="status"
                [i]="i"
              ></sort-filter-images>
            </button>
            <ul
              *dropdownMenu
              class="dropdown-menu dropdown-menu-right"
              role="menu"
            >
              <li>
                <sort-radio-btns
                  [sortColumns]="sortsAndFilters?.sortColumns"
                  [column]="column"
                  [groupStatusSort]="groupStatusSort"
                  (radioBtnSelected)="sort($event)"
                ></sort-radio-btns>
              </li>
              <li><hr /></li>
              <li>
                <filter-select-and-inputs
                  [filterColumns]="sortsAndFilters?.filterColumns"
                  [selectedFilterItem]="selectedFilterItem"
                  [column]="column"
                  [noFilterObj]="noFilterObj"
                  [betweenObj]="betweenObj"
                  [equalToObj]="equalToObj"
                  [greaterThanObj]="greaterThanObj"
                  [lessThanObj]="lessThanObj"
                  [filterItems]="filterItems"
                  (minChange)="minChange($event)"
                  (maxChange)="maxChange($event)"
                  (singleValChange)="singleValChange($event)"
                  (filterChange)="filter($event)"
                  *ngIf="column && column.id != -1"
                >
                </filter-select-and-inputs>
                <group-status-filters
                  [groupStatusFilters]="groupStatusFilters"
                  (groupStatusFilterChange)="groupStatusFilterChange($event)"
                  *ngIf="column && column.id == -1"
                ></group-status-filters>
              </li>
              <li>
                <div class="action-btns">
                  <button
                    mat-raised-button
                    (click)="cancel()"
                    color="secondary"
                    class="confirm-btns cancel-btn"
                  >
                    CANCEL
                  </button>
                  <button
                    mat-raised-button
                    (click)="submit(column, false)"
                    color="primary"
                    class="confirm-btns submit-btn"
                  >
                    OK
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="view-criteria-div">
          <view-criteria
            [sortColumns]="sortsAndFilters?.sortColumns"
            [filterColumns]="sortsAndFilters?.filterColumns"
            [column]="column"
          ></view-criteria>
        </div>
        <div class="group-status-criteria-div" *ngIf="column.id == -1">
          <!--Sorted/Filtered text for Group Status column -->
          <p *ngIf="groupStatusSort && groupStatusSort != 'CLEAR'">Sorted</p>
          <p
            *ngIf="
              groupStatusFilters &&
              groupStatusFilters.length >= 0 &&
              groupStatusFilters.length < 3
            "
          >
            Filtered
          </p>
          <!--Only show "filtered" text if zero, one or two filter boxes are checked -->
        </div>
        <ng-template #titleTooltip>
          <title-tooltip
            [definition]="
              column?.id == -1
                ? groupStatusColumnDef
                : schoolOverall[column?.id]?.titleTooltip
            "
            [title]="column?.title"
            [hidePrefix]="true"
          ></title-tooltip>
        </ng-template>
      </th>
    </tr>
    <tr class="overall-row">
      <th
        class="overall-col"
        *ngFor="let column of columns; let first = first; let last = last"
        [ngClass]="column.title == GROUP_STATUS_CONSTANT ? 'group-status' : ''"
      >
        <div
          *ngIf="
            school &&
            school[column.id] &&
            school[column.id]['distribution'] &&
            school[column.id]['distribution'].length > 0
          "
        >
          <!-- display clickable bar-->
          <clickable-bar
            [last]="last"
            [studentKpiId]="column.id"
            [data]="school[column.id]['distribution']"
            (selectedSegment)="segmentEvent($event)"
            [column]="column"
            [prefix]="school[column.id]['overallPrefix']"
            [suffix]="school[column.id]['overallSuffix']"
            [overallSubtitle]="school[column.id]['overallSubtitle']"
          ></clickable-bar>
          <span class="goal-value">{{ school[column.id]["goal"] }}</span>
        </div>
        <div
          *ngIf="
            school &&
            school[column.id] &&
            school[column.id]['overall'] != null &&
            (!school[column.id]['distribution'] ||
              (school[column.id]['distribution'] &&
                school[column.id]['distribution'].length == 0))
          "
        >
          <!-- display number -->
          <span
            class="overall-value"
            [ngStyle]="{ color: school[column.id]['color'] }"
            [tooltip]="schoolValueTooltip"
            [placement]="last ? 'left' : 'top'"
            container="body"
          >
            {{ school[column.id]["overallPrefix"]
            }}{{ school[column.id]["overall"] | number
            }}{{ school[column.id]["overallSuffix"] }}
          </span>
          <span class="goal-value">{{ school[column.id]["goal"] }}</span>
        </div>
        <div
          *ngIf="
            (!school ||
              !school[column.id] ||
              (school[column.id] && school[column.id]['overall'] == null)) &&
            column.id != -1
          "
          class="no-data-col"
        >
          <img
            [src]="'../assets/images/no_data.png'"
            class="no-data-image"
            alt="No data available!"
            container="body"
            [tooltip]="schoolValueTooltip"
            [placement]="last ? 'left' : 'top'"
          />
        </div>

        <ng-template #schoolValueTooltip>
          <comp-overall-value-tooltip
            [studentTooltip]="true"
            [overallData]="school"
            [column]="districtMetrics[column.id]"
            [kpiId]="column.id"
          ></comp-overall-value-tooltip>
        </ng-template>
      </th>
    </tr>
  </thead>
</table>
